// Local translations
export const T = {
  en_GB: {
    // Header
    addTab: "Add Tab",
    clientTabsTitle: "Client Tabs",
    clientTabsDescription:
      "Organize client fields into tabs for better organization in the client edit modal.",
    // Table
    name: "Name",
    fields: "Fields",
    actions: "Actions",
    edit: "Edit",
    defaultTab: "Default",
    systemTab: "System tab",
    // Dialog
    editTab: "Edit Tab",
    addNewTab: "Add New Tab",
    updateTabDescription: "Update the tab name.",
    createTabDescription: "Create a new tab to organize client fields.",
    tabName: "Tab Name",
    tabNamePlaceholder: "e.g., Contact Info, CRM, Compliance",
    // Actions
    cancel: "Cancel",
    save: "Save",
    delete: "Delete",
    // Delete confirmation
    deleteTab: "Delete Tab",
    deleteTabConfirmation: (name: string) =>
      `Are you sure you want to delete "${name}"? Fields will be moved to the Default tab.`,
    // Errors
    error: "Error",
    ok: "OK",
    failedToDelete: "Failed to delete custom field",
    somethingWentWrong: "Something went wrong",
  },
  nb_NO: {
    // Header
    addTab: "Legg til fane",
    clientTabsTitle: "Kundefaner",
    clientTabsDescription: "Organiser kundefelt i faner for bedre oversikt i redigeringsvinduet.",
    // Table
    name: "Navn",
    fields: "Felt",
    actions: "Handlinger",
    edit: "Rediger",
    defaultTab: "Standard",
    systemTab: "Systemfane",
    // Dialog
    editTab: "Rediger fane",
    addNewTab: "Legg til ny fane",
    updateTabDescription: "Oppdater fanenavnet.",
    createTabDescription: "Opprett en ny fane for å organisere kundefelt.",
    tabName: "Fanenavn",
    tabNamePlaceholder: "f.eks. Kontaktinfo, CRM, Compliance",
    // Actions
    cancel: "Avbryt",
    save: "Lagre",
    delete: "Slett",
    // Delete confirmation
    deleteTab: "Slett fane",
    deleteTabConfirmation: (name: string) =>
      `Er du sikker på at du vil slette "${name}"? Felt flyttes til Standard-fanen.`,
    // Errors
    error: "Feil",
    ok: "OK",
    failedToDelete: "Kunne ikke slette egendefinert felt",
    somethingWentWrong: "Noe gikk galt",
  },
} as const;
